import React, { useEffect, useMemo, useRef, useState } from "react";
import Toggle from 'theme/Toggle';
import Text from "theme/Text";
import { CommonActions, useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import _, { times } from 'lodash';
import i18n from "utils/i18n";
import { textStyles } from "styles/text";
import { dataConstants } from "services/redux/data/constants";
import { bookingConstants } from "utils/constants/booking-constants";
import { Keyboard, StyleSheet, View } from "react-native";
import { cartConstants } from "services/redux/cart/constants";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import { layoutStyles } from "styles/layout";
import { colorList } from "utils/colors";
import { AppRoutes } from "navigations/app-routes";
import ObjectBooking from "utils/objects/booking";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import ThemedBlock from "components/atoms/ThemedBlock";
import FetchError from "components/molecules/FetchError";
import HelperCart from 'utils/helper-cart'
import Form from 'components/molecules/Form'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import { ThemedValues } from 'styles/themed'
import BookingFooter from 'scenes/home/book/_components/BookingFooter'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import ValidateBookingFunctions from 'scenes/home/book/validate/_functions/ValidateBookingFunctions'
import ReactTimeout from 'react-timeout'
import BookingBlocks from 'scenes/home/book/validate/_components/BookingBlocks'
import EmployeeBlock from 'scenes/home/book/validate/_components/EmployeeBlock'
import HelperString from 'utils/helper-string'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import { setEmployeeStatus } from 'services/redux/cart/actions'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import Modal from 'components/atoms/Modal'
import { TESTID } from '_shared/config/testID'
import VStack from 'components/atoms/stack/VStack'
import Captcha from 'components/organisms/Captcha'
import HelperAlerts from 'utils/HelperAlerts'
import ThemedToggle from "components/atoms/ThemedToggle";
import useFetch from "utils/hooks/useFetch";
import FetchCreditAmounts from "utils/fetch/FetchCreditAmounts";
import ListItemCredit from "components/molecules/ListItemCredit";
import HStack from "components/atoms/stack/HStack";
import Button from "theme/Button";

const HomeBookValidateScene = ({ setTimeout, clearTimeout }) => {
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const route = useRoute();
	const dispatch = useDispatch();
	const _routeParameters = useRouteParameters( route );
	
	const captchaRef = useRef( undefined )
	
	const [ loading, setLoading ] = useState( true )
	const [ error, setError ] = useState( false )
	const [ validating, setValidating ] = useState( false )
	const [ submitted, setSubmitted ] = useState( false )
	const [ submitting, setSubmitting ] = useState( false )
	const [ showInvitedEmployeesChecked, setShowInvitedEmployeesChecked ] = useState( true )
	const [ days, setDays ] = useState( {} )
	const [ formValues, setFormValues ] = useState( {} )
	const [ bookingSize, setBookingSize ] = useState( 0 )
	const [ footerHeight, setFooterHeight ] = useState( 0 )
	
	const _employeeStatus = useSelector( state => {
		return state.cart[cartConstants.EMPLOYEE_STATUS];
	} );
	const _cartBookings = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} )
	const _cartTimeslotsLunchOptions = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS_LUNCH_OPTIONS];
	} );
	
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} );
	const _floors = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} );
	const _rooms = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} );
	
	const _cartEmployees = useSelector( selectCartEmployees );
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _bookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	const cartBookingsFlat = ValidateBookingFunctions.createFlatList( _cartBookings )

	const { data: dataCreditAmounts, loading: loadingCreditAmounts, refetch: refetchCreditAmounts } = useFetch( FetchCreditAmounts.fetchAll );

	const bookingCreditsRequired = useMemo( () => {

		// Check if the bookings require credits
		let requiredCredits = {};
		_.forEach( cartBookingsFlat, booking => {
			const creditRequired = ObjectBooking.isCreditRequired( booking );

			if( creditRequired.required ) {
				if( !_.has( requiredCredits, creditRequired.timeslot_kind.guid ) ) {
					requiredCredits[ creditRequired.timeslot_kind.guid ] = {
						timeslot_kind: creditRequired.timeslot_kind,
						credit_amount: 0,
					};
				}

				requiredCredits[ creditRequired.timeslot_kind.guid ].credit_amount += creditRequired.credit_amount;
			}
		});

		// Check if the credits are available in the dataCreditAmounts
		const result = []
		_.forEach( requiredCredits, ( item, guid ) => {
			const creditAmount = _.find( dataCreditAmounts, { timeslot_kind: { guid } } );
			if( !creditAmount || creditAmount.amount_unused < item.credit_amount ) {
				result.push({
					...item,
					credit_amount_required: item.credit_amount,
					amount_unused: creditAmount ? creditAmount.amount_unused : 0,
				});
			}
		})

		return result
	}, [ dataCreditAmounts, cartBookingsFlat ] )
	
	const areBookingsInvitation = () => {
		let isInvitation = false;
		
		_.forEach( cartBookingsFlat, booking => {
			if( ObjectBooking.isInvitation( booking ) ) {
				isInvitation = true;
			}
		});
		
		return isInvitation;
	}
	
	const createData = () => {
		// Prepare
		const days = {};
		const daysFlat = {};
		
		// Create the bookings
		const bookings = _.sortBy( cartBookingsFlat, [ 'booking_date', 'timeslot.timeslot_start' ] );
		
		// Sort by kind
		_.forEach( bookings, booking => {
			const bookingDate = booking.booking_date;
			
			// Create the day object
			if( !_.has( days, bookingDate ) ) {
				days[ bookingDate ] = {
					[ bookingConstants.BOOKING ]: [],
					[ bookingConstants.MEETING_ROOM ]: [],
					[ bookingConstants.LUNCH ]: [],
					[ bookingConstants.TRANSPORT ]: [],
					[ bookingConstants.CUSTOM ]: [],
				};
			}
			
			// Check by kind what to do
			switch( booking?.kind ) {
				case bookingConstants.LUNCH:
					const timeslotLunchOption = _.get( _cartTimeslotsLunchOptions, FetchTimeslotCapacity.keyByBooking( booking ), null );
					
					if( timeslotLunchOption !== null ) {
						booking['lunch_options'] = [{
							lunch_option: {
								guid: timeslotLunchOption
							}
						}];
					}
					
					days[ bookingDate ][ booking?.kind ].push( booking );
					break;
				
				default:
					days[ bookingDate ][ booking?.kind ].push( booking );
			}
		})
		
		// Sort by date/building
		_.forEach( days, ( kinds, day ) => {
			const dayData = {};
			
			_.forEach( kinds, bookings => {
				_.forEach( bookings, booking => {
					const { key, title } = ObjectBooking.extractKeyTitle( booking, {
						_buildings,
						_floors,
						_rooms
					})
					
					if( !_.has( dayData, key ) ) {
						dayData[ key ] = {
							title: title,
							first: _.size( dayData ) === 0,
							data: []
						};
					}
					
					dayData[ key ].data.push( booking );
				})
			});
			
			if( _.size( dayData ) > 0 ) {
				let dayObjectNr = 1;
				
				daysFlat[ day ] = _.map( dayData, (object) => {
					// Is it the last?
					object['last'] = _.size( dayData ) === dayObjectNr++;
					
					return object
				} );
			}
		});
		
		setDays( daysFlat )
		setBookingSize( _.size( bookings ) )
	}
	
	const onSetEmployeeStatus = ( employee ) => {
		dispatch( setEmployeeStatus( ValidateBookingFunctions.updateEmployeeStatus( _employeeStatus, employee ) ) );
	}
	
	const onBeforeSave = () => {
		setValidating( true )
		
		captchaRef.current?.validate( ( { isValid } ) => {
			setValidating( false )
			
			if( !isValid ) {
				HelperAlerts.alert(
					i18n.t('page.create.overview.captcha_modal.title' ),
					i18n.t('page.create.overview.captcha_modal.text' ),
					[
						{
							text: i18n.t( 'buttons.ok' ),
						}
					]
				);
				return
			}
			
			// Save the data
			onSave()
		})
	}
	
	const onSave = () => {
		setSubmitting( true )
		
		// Count the 'other' people selected
		let otherPersonsSelectedSize = 0;
		_.forEach( _cartEmployees, ( employee, guid ) => {
			if( guid !== _employee.guid ) {
				otherPersonsSelectedSize++;
			}
		})
		
		// Are there 'other' people selected, then create the invitation
		if( otherPersonsSelectedSize > 0 ) {
			let hasToCreateInvitation = false;
			_.forEach( cartBookingsFlat, booking => {
				if( booking._invitation === null ) {
					hasToCreateInvitation = true;
					return true;
				}
			});
			
			// Create the invitation
			if( hasToCreateInvitation ) {
				ValidateBookingFunctions.createInvitation({
					values: formValues,
					showInvitees: showInvitedEmployeesChecked,
					employeeStatus: _employeeStatus,
					bookForOption: _bookForOption,
					onSetEmployeeStatus: onSetEmployeeStatus,
					onSuccess: onSuccess,
					onError: onError
				})
				return;
			}
		}
		
		// First save the 'new' external employees
		if( _.size( _bookingExternalPersons ) > 0 ) {
			ValidateBookingFunctions.createExternalEmployee({
				values: formValues,
				showInvitees: showInvitedEmployeesChecked,
				employeeStatus: _employeeStatus,
				bookForOption: _bookForOption,
				onSetEmployeeStatus: onSetEmployeeStatus,
				onSuccess: onSuccess,
				onError: onError
			})
			return;
		}
		
		// At last, create the bookings :)
		// This is only happening when there are NO others to be invited
		
		ValidateBookingFunctions.createBookings({
			values: formValues,
			employeeStatus: _employeeStatus,
			bookForOption: _bookForOption,
			onSuccess: onSuccess,
			onError: onError
		});
	}
	
	const onSuccess = () => {
		setSubmitting( false );
		setSubmitted( true );
	}
	
	const onError = () => {
		setSubmitting( false );
		setSubmitted( false );
		setError( true );
	}
	
    const onPressBuyCredits = ( item ) => {
        // Navigate to the buy credits screen
        navigation.navigate( AppRoutes.MORE_CREDITS_BUY, {
            timeslot_kind_guid: item?.timeslot_kind?.guid,
			fromBooking: true
        });
    }

	useEffect( () => {
		if( isFocused ) {
			if( !loadingCreditAmounts ) {
				refetchCreditAmounts();
			}
		}
	}, [ isFocused ])

	// Update the data when bookings change
	useEffect( () => {
		return createData();
	}, [ _cartBookings ] )
	
	useEffect( () => {
		navigation.setOptions( {
			gestureEnabled: !( validating || submitting || submitted),
		});
		
		if( submitted ) {
			navigation.dispatch( CommonActions.reset( {
				index: 1,
				routes: [
					{
						name: AppRoutes.ADD_BOOKING_SUCCESS,
						params: {
							bookingSize: bookingSize,
							[ routeBookingConstants.FOR_OPTION ]: _bookForOption,
							[ routeBookingConstants.THROUGH_QR_SCAN ]: _.get( _routeParameters, routeBookingConstants.THROUGH_QR_SCAN, routeBookingConstantValues[ routeBookingConstants.THROUGH_QR_SCAN ].NO )
						}
					}
				]
			}));
		}
	}, [ validating, submitting, submitted ] );
	
	// After load set loading false
	useEffect( () => {
		return setLoading(false);
	}, [])
	
	const isInvitation = areBookingsInvitation();
	
	if( !loading && ( submitting || submitted ) ){
		return (
			<Modal animationOnMount={ 'fadeIn' } testID={ TESTID.HOME.BOOK.VALIDATE.LOADING_MODAL }>
				<LoadingComponent size={ 'l' } />
				<Text> {i18n.t( 'saving.booking')}</Text>
			</Modal>
		);
	}
	
	let content = <LoadingComponent size={ 'l' } />
	if( !loading ) {
		switch( true ) {
			case error:
				content = (
					<FetchError
						action={ createData.bind( this ) }
					/>
				)
				break;
				
			case submitted:
				content = (
					<LoadingComponent size={ 'l' } />
				)
				break;
				
			case _.isEmpty( days ):
				content = (
					<Text
						key={ HelperString.hash( 'content-no-timeslots' ) }
						style={ [ textStyles.textCenter, styles.textTop, styles.textColorPrimary ] }>
						
						{ i18n.t('page.create.overview.no_timeslots', { count: _.size( _cartBookings ) } ) }
					</Text>
				)
				break;
				
			default:
				const formFields = [];
				
				if( HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_REASON ) ) {
					formFields.push({
						name: 'reason',
						label: i18n.t('page.create.overview.form.reason.title'),
						type: FormFieldsConstants.TEXT_AREA,
						props: {
							returnKeyType: 'done',
							onSubmitEditing: Keyboard.dismiss
						}
					});
				}
				
				if( HelperCart.bookingForMultiple() ) {
					formFields.push({
						name: 'name',
						required: true,
						label: i18n.t('page.create.overview.form.name.title'),
						type: FormFieldsConstants.TEXT,
						props: { returnKeyType: 'done', onSubmitEditing: Keyboard.dismiss }
					});
					
					formFields.push({
						name: 'description',
						label: i18n.t('page.create.overview.form.description.title'),
						type: FormFieldsConstants.TEXT_AREA,
						props: { returnKeyType: 'done', onSubmitEditing: Keyboard.dismiss }
					});
				}
				
				content = [];
				
				if( HelperCart.bookingForMultiple() ) {
					content.push(
						<EmployeeBlock
							key={ HelperString.hash( 'content-user-block' ) }
							status={ _employeeStatus }
							bookForOption={ _bookForOption }
						/>
					)
				}
				
				content.push(
					<BookingBlocks
						key={ HelperString.hash( 'content-booking-block' ) }
						days={ days }
					/>
				)
				
				if( !_.isEmpty( formFields ) && !isInvitation ) {
					content.push(
						<ThemedBlock
							key={ HelperString.hash( 'content-invitation-form' ) }
							mediumPadding
							shadow>
							
							{/* Form for reason or title+description */}
							<Form
								values={ formValues }
								fields={ formFields }
								onlyFields={ true }
								onChange={ setFormValues.bind( this ) }
							/>
							
							{/* Only for invitation */}
							<If condition={ HelperCart.bookingForMultiple() }>
								<View style={ styles.toggleContainer }>
									<ThemedToggle
										checked={ showInvitedEmployeesChecked }
										onPress={ setShowInvitedEmployeesChecked.bind( this, !showInvitedEmployeesChecked ) }>
										
										{ i18n.t('page.create.overview.form.show_invitees.title') }
									</ThemedToggle>
								</View>
							</If>
						</ThemedBlock>
					)
				}

				if( _.size( bookingCreditsRequired ) > 0 ) {
					content.push(
						<ThemedBlock
							key={ HelperString.hash( 'content-booking-credits-required' ) }
							shadow>
							
							{ _.map( bookingCreditsRequired, ( credit, index ) => {
								return (
									<ListItemCredit
										key={ HelperString.hash( 'booking-credit-required', index ) }
										item={ credit }
										accessoryRight={(
											<HStack>
												<Button
													onPress={ onPressBuyCredits.bind( this, credit ) }>

													{ i18n.t( 'buttons.buy' ) }
												</Button>
											</HStack>
										)}>

										<Text>{ i18n.t('page.credits.item.not_enough') }</Text>
									</ListItemCredit>
								);
							})}
						</ThemedBlock>
					)
				}
				
				if( submitting ) {
					content.push(
						<LoadingComponent
							fullscreen={ true }
							size={ 'l' }
						/>
					)
				}
		}
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				contentWidth="narrow"
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t('page.create.overview.title' ) }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ content }
					
					<Captcha
						ref={ captchaRef }
					/>
				</VStack>
			</ThemedLayout>
			
			<BookingFooter
				onHeight={ setFooterHeight }
				visible={ !isInvitation }
				disabled={ _.size( bookingCreditsRequired ) > 0 }
				loading={ validating || submitting || loadingCreditAmounts }
				submitLabel={ i18n.t( 'page.create.overview.booking_save' ) }
				onPressSubmit={ onBeforeSave.bind( this ) }
				showBookings={ false }
			/>
		</ThemedSafeAreaComponentTop>
	)
}

const styles = StyleSheet.create( {
	textColorPrimary: {
		color: colorList.RED.primary,
	},
	container: {
		paddingHorizontal: ThemedValues.marginHorizontal,
	},
	containerButton: {
		flex: 0,
		...layoutStyles.bottomButtonContainer
	},
	textTop: {
		fontWeight: 'bold',
		marginVertical: 20,
		color: colorList.PRIMARY.primary
	},
	toggleContainer: {
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
	toggle: {
		margin: 4,
		paddingBottom: 12
	},
});

export default ReactTimeout( HomeBookValidateScene )
